import { useDelete } from '../../utils/reactQuery';
import { ApiRoutesEnum } from '../../utils/routes';

export const useDeleteCandidateNote = () => {
  return useDelete({
    url: ApiRoutesEnum.candidateUpdateNote,
  });
};
